import React from 'react';
import shimbun8 from '../assets/shimbun8.png';
import shimbun9 from '../assets/shimbun9.png';
import shimbun10 from '../assets/shimbun10.png';
import shimbun11 from '../assets/shimbun11.png';
import './CSS/Interview.css';

function Interview3() {
  return (
    <main className="interview-page">
      <div className="interview-masthead">
        BUDO JAPAN Exclusive &nbsp;·&nbsp; บทความพิเศษ &nbsp;·&nbsp; Special Feature
      </div>

      {/* HERO */}
      <section className="interview-hero">
        <img
          className="interview-hero-img"
          src={shimbun8}
          alt="ฟูกากูซ่า ชิฮัง ให้สัมภาษณ์"
        />

        <div className="interview-hero-overlay"></div>

        <div className="interview-hero-content">
          <div className="interview-hero-label">
            บทความพิเศษ · BUDO JAPAN (2020)
          </div>

          <h1 className="interview-hero-title">
            บิดาแห่งไอคิโดในแผ่นดินไทย
            <br />
            <em>ชายผู้พาศิลปะแห่งสันติสู่ดินแดนแห่งมวยไทย</em>
          </h1>

          <p className="interview-hero-subtitle">
            เรื่องราวของ โมโตฮิโร ฟูกากูซา (Motohiro Fukakusa) ผู้ได้รับมอบหมายให้มาเผยแพร่ไอคิโดในประเทศไทยด้วยประสบการณ์ฝึกฝนเพียง 3 ปี
          </p>

          <div className="interview-hero-byline">
            <div className="interview-hero-avatar">
              <img src={shimbun8} alt="Grigoris Miliaresis" />
            </div>

            <div className="interview-hero-byline-text">
              <strong>Grigoris Miliaresis</strong>
              ผู้เขียนบทความ · Budo Japan
            </div>
          </div>
        </div>
      </section>

      <div className="interview-article-wrap">
        <div className="interview-intro-block">
          <p>
            แม้ผู้เขียนจะฝึกไอคิโดมาเกือบทศวรรษและอาศัยอยู่ในประเทศญี่ปุ่น แต่เขากลับไม่เคยได้ยินชื่อของ โมโตฮิโร ฟูกากูซา มาก่อนจนกระทั่งได้รับมอบหมายให้เขียนบทความนี้ ทว่าเมื่อเขาได้ไปเยือนศูนย์เยาวชนแห่งชาติโยโยกิ เขาก็ตระหนักทันทีว่านี่คือบุคคลที่มีความสำคัญอย่างยิ่งยวดต่อวงการศิลปะการต่อสู้
          </p>
        </div>

        {/* SECTION 1 */}
        <div className="interview-section-header">
          <div className="interview-section-num">01</div>
          <div className="interview-section-title-wrap">
            <span>จุดเริ่มต้น · The Beginning</span>
            <h2>ภารกิจที่เป็นไปไม่ได้</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float">
            <img
              src={shimbun9}
              alt="โมโตฮิโร ฟูกากูซา"
            />
            <figcaption>
              โมโตฮิโร ฟูกากูซา ได้รับมอบหมายให้มาเผยแพร่ไอคิโดในประเทศไทยด้วยประสบการณ์ฝึกฝนเพียง 3 ปี
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                จุดเริ่มต้นของอาจารย์ฟูกากูซาในประเทศไทยเป็นอย่างไรครับ?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                เขาเริ่มต้นฝึกไอคิโดในช่วงต้นทศวรรษ 1960 ซึ่งเป็นยุคที่สำนักงานใหญ่ของไอคิโดยังคงอยู่ภายใต้การดูแลของ โมริเฮ อูเอชิบา (Ueshiba Morihei) ผู้ก่อตั้งศิลปะแขนงนี้ ในเวลานั้นเขาได้รับมอบหมายภารกิจที่ยากลำบากอย่างยิ่ง นั่นคือการนำวิชาไอคิโดไปเผยแพร่ในประเทศไทย
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                ทำไมภารกิจนี้ถึงถูกมองว่าเป็นเรื่องยาก?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                เพราะประเทศไทยเป็นดินแดนที่มี "มวยไทย" เป็นศิลปะการต่อสู้ที่ฝังรากลึกในจิตสำนึกของคนท้องถิ่นอยู่ก่อนแล้วครับ สิ่งที่น่าทึ่งคือ เขาเริ่มต้นภารกิจนี้ด้วยประสบการณ์การฝึกฝนเพียง 3 ปี และมีคุณวุฒิระดับสายดำเพียง 2 ดัน ซึ่งมอบให้โดยตรงจากปรมาจารย์อูเอชิบา
              </div>
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "และเขาก็ทำสำเร็จ! แม้จะเผชิญกับความยากลำบากนานัปการ เขาก็สามารถสถาปนาไอคิโดได้ ไม่เพียงแต่ในประเทศไทย แต่รวมถึงพื้นที่ที่กว้างใหญ่ของเอเชียตะวันออกเฉียงใต้"
          </p>
          <cite>— Grigoris Miliaresis</cite>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">เรนบูกัง · Renbukan</span>
          <h3>รากฐานแห่งการฝึกฝน</h3>
          <p>
            จากความพยายามอย่างหนัก ฟูกากูซาได้นำกลุ่มผู้ฝึกไอคิโดย้ายจากวิทยาลัยพลศึกษา ณ สนามกีฬาแห่งชาติ มาสู่โดโจของตนเองในชื่อ "เรนบูกัง" (Renbukan) ได้สำเร็จ
          </p>
        </div>

        <div className="interview-concept-card">
          <span className="interview-concept-jp">เครือข่าย · ASEANF</span>
          <h3>ขยายสู่อาเซียน</h3>
          <p>
            ในปี พ.ศ. 2551 (ค.ศ. 2008) เขาได้ก่อตั้งเครือข่ายระดับภูมิภาคเพื่อเป็นฐานอันมั่นคงให้กับวิชาแขนงนี้ เครือข่าย ASEANF ครอบคลุมทั้งไทย กัมพูชา ลาว มาเลเซีย เมียนมา ฟิลิปปินส์ สิงคโปร์ และเวียดนาม
          </p>
        </div>

        {/* SECTION 2 */}
        <div className="interview-section-header">
          <div className="interview-section-num">02</div>
          <div className="interview-section-title-wrap">
            <span>การประชุมนานาชาติ · International Congress</span>
            <h2>ชั้นเรียนของ "คุณสมชาย"</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float" style={{ float: 'right', marginLeft: '24px', marginRight: '0' }}>
            <img src={shimbun10} alt="ชั้นเรียนของคุณสมชาย" />
            <figcaption>
              การสอนของ "คุณสมชาย" ดึงดูดผู้ฝึกกว่า 400 คนบนเบาะทาทามิได้อย่างอยู่หมัด
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                คุณมีโอกาสได้เห็นการสอนของเขาด้วยตัวเองใช่ไหมครับ?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                ใช่ครับ ในการประชุมไอคิโดนานาชาติครั้งที่ 11 ณ กรุงโตเกียว (ค.ศ. 2012) ผมได้มีโอกาสสังเกตการณ์ชั้นเรียนของฟูกากูซา หรือที่ชาวไทยรู้จักกันในนาม "คุณสมชาย" (Khun Somchai) ที่ศูนย์เยาวชนแห่งชาติโยโยกิ
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                บรรยากาศในชั้นเรียนวันนั้นเป็นอย่างไรบ้าง?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                ทันทีที่การอบอุ่นร่างกายตามมาตรฐานสิ้นสุดลง และการสอนเริ่มต้นขึ้น ความกังขาใด ๆ ที่ผมมีก็มลายหายไป เขาสามารถดึงดูดความสนใจของผู้ฝึกกว่า 400 คนบนเบาะทาทามิได้อย่างอยู่หมัด เขาเน้นย้ำถึงความสำคัญของการผ่อนคลายร่างกาย ว่าความผ่อนคลายที่แท้จริงต้องไม่ใช่การปล่อยตัวอ่อนปวกเปียก แต่ต้องมีพลังงานเส้นประสาทที่เพียงพอต่อการควบคุมคู่ต่อสู้ และมีความนุ่มนวลพอที่จะปรับท่าทางตามปฏิกิริยาของอีกฝ่ายได้อย่างเป็นธรรมชาติ
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3 */}
        <div className="interview-section-header">
          <div className="interview-section-num">03</div>
          <div className="interview-section-title-wrap">
            <span>อิทธิพลจากท้องถิ่น · Local Influence</span>
            <h2>ช่องโหว่และการตระหนักรู้</h2>
          </div>
        </div>

        <div className="interview-clearfix">
          <figure className="interview-portrait-float">
            <img src={shimbun11} alt="ช่องโหว่และการตระหนักรู้" />
            <figcaption>
              การโจมตี (Atemi) ที่รวดเร็วเพื่อชี้ให้เห็นช่องโหว่ของคู่ฝึก
            </figcaption>
          </figure>

          <div className="interview-conversation">
            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                การสอนในประเทศที่มีมวยไทยส่งผลต่อสไตล์ของเขาอย่างไรครับ?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                ผมตั้งข้อสังเกตว่า ความเฉียบคมและการรับรู้ถึงช่องโหว่ของอาจารย์ฟูกากูซา น่าจะมีผลมาจากการที่เขาต้องพิสูจน์วิชาไอคิโด ต่อหน้าผู้คนที่คุ้นเคยกับหนึ่งในรูปแบบการชกมวยที่ไร้ความปรานีที่สุดในโลกอย่าง มวยไทย (Thai boxers) มาอย่างยาวนาน
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag q">
                <span>ถาม</span>
              </div>
              <div className="interview-exchange-text">
                เขาสาธิตให้ผู้ฝึกเห็นถึงความสำคัญของเรื่องนี้อย่างไร?
              </div>
            </div>

            <div className="interview-exchange">
              <div className="interview-speaker-tag a">
                <span>ผู้เขียน</span>
              </div>
              <div className="interview-exchange-text">
                ทุกครั้งที่เขาเลือกคู่ฝึกมาสาธิต เขาจะชี้ให้เห็นช่องโหว่ของคู่ฝึกด้วยการโจมตี (Atemi) ที่รวดเร็วมาก การทำเช่นนี้เป็นการย้ำเตือนสิ่งที่มักขาดหายไปในไอคิโด นั่นคือความตระหนักว่านี่คือ "ศิลปะการต่อสู้" และคู่ฝึกควรถูกมองว่าเป็นคู่ต่อสู้ที่พร้อมจะฉวยโอกาสจากทุกช่องโหว่
              </div>
            </div>
          </div>
        </div>

        <div className="interview-pull-quote">
          <p>
            "เทคนิคที่เริ่มต้นหรือดำเนินไปโดยมีช่องโหว่ คือเทคนิคที่ขาดความตระหนักรู้ ซึ่งผลลัพธ์ของมันย่อมจะอ่อนแอและนำไปสู่ความล้มเหลว"
          </p>
          <cite>— หลักการที่เน้นย้ำโดย โมโตฮิโร ฟูกากูซา</cite>
        </div>

        <div className="interview-ornament">— · · · —</div>

        <div className="interview-closing-box">
          <h3>บทสรุป: 50 ปีแห่งความทุ่มเท</h3>
          <p>
            โมโตฮิโร ฟูกากูซา ได้พิสูจน์ให้เห็นแล้วว่า ภารกิจที่ดูเหมือนเป็นไปไม่ได้ของชายหนุ่มผู้มีประสบการณ์เพียง 3 ปี ได้ผลิดอกออกผลกลายเป็นรากฐานที่แข็งแกร่งของไอคิโดในภูมิภาคเอเชียตะวันออกเฉียงใต้ ปัจจุบันท่านถือครองคุณวุฒิสายดำระดับ 8 ดัน ซึ่งเป็นเครื่องชดเชยที่คู่ควรกับการทำงานหนักตลอด 50 ปี
          </p>
          <p className="interview-closing-note">
            "สิ่งนี้คือมรดกอันยิ่งใหญ่ที่ บิดาแห่งไอคิโดในประเทศไทย ได้ฝากไว้ให้กับวงการศิลปะการต่อสู้โลก"
          </p>
        </div>
      </div>

      <footer className="interview-footer">
        <strong>ที่มาข้อมูล</strong>
        <br />
        อ้างอิงและเรียบเรียงจากบทความ "International Aikido Federation's 11th International Aikido Congress (Tokyo, 2012): Fukakusa Motohiro' class" เขียนโดย Grigoris Miliaresis ตีพิมพ์ใน Budo Japan (2020) และไฟล์ข้อมูล aikido_thailand_history (3).html
      </footer>
    </main>
  );
}

export default Interview3;
